export { StructuredData } from './StructuredData';

export type { StructuredDataProps, StructuredDataType } from './StructuredData';
